import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import RegisterApi from "../../../Services/Register";
import DriverApi from "../../../Services/Driver";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import { showSnackbar } from "Redux/SnackBar/actions";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import "./signUpDriverV2.css";

const stepLabels = [
  { number: 1, lines: ["signupDriverV2.step.label1.line1", "signupDriverV2.step.label1.line2"] },
  { number: 2, lines: ["signupDriverV2.step.label2.line1", "signupDriverV2.step.label2.line2"] },
  { number: 3, lines: ["signupDriverV2.step.label3.line1"] },
  { number: 4, lines: ["signupDriverV2.step.label4.line1"] },
];

const stepIntroContent = {
  1: {
    eyebrowKey: "signupDriverV2.intro.eyebrow.step1",
    titleKey: "signupDriverV2.intro.title.step1.line1",
    summaryKey: "signupDriverV2.intro.summary.step1",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step1", textKey: "signupDriverV2.intro.item1.text.step1", icon: UserIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step1", textKey: "signupDriverV2.intro.item2.text.step1", icon: ShieldFeatureIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step1", textKey: "signupDriverV2.intro.item3.text.step1", icon: ArrowRightIcon },
    ],
  },
  2: {
    eyebrowKey: "signupDriverV2.intro.eyebrow.step2",
    titleKey: "signupDriverV2.intro.title.step2.line1",
    summaryKey: "signupDriverV2.intro.summary.step2",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step2", textKey: "signupDriverV2.intro.item1.text.step2", icon: CheckIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step2", textKey: "signupDriverV2.intro.item2.text.step2", icon: CarFeatureIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step2", textKey: "signupDriverV2.intro.item3.text.step2", icon: ArrowRightIcon },
    ],
  },
  3: {
    eyebrowKey: "signupDriverV2.intro.eyebrow.step3",
    titleKey: "signupDriverV2.intro.title.step3.line1",
    summaryKey: "signupDriverV2.intro.summary.step3",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step3", textKey: "signupDriverV2.intro.item1.text.step3", icon: PaperclipIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step3", textKey: "signupDriverV2.intro.item2.text.step3", icon: CheckIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step3", textKey: "signupDriverV2.intro.item3.text.step3", icon: ShieldFeatureIcon },
    ],
  },
  4: {
    eyebrowKey: "signupDriverV2.intro.eyebrow.step4",
    titleKey: "signupDriverV2.intro.title.step4.line1",
    summaryKey: "signupDriverV2.intro.summary.step4",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step4", textKey: "signupDriverV2.intro.item1.text.step4", icon: UserIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step4", textKey: "signupDriverV2.intro.item2.text.step4", icon: CheckIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step4", textKey: "signupDriverV2.intro.item3.text.step4", icon: ArrowRightIcon },
    ],
  },
};

const featureItems = [
  { titleKey: "signupDriverV2.feature.title1", textKey: "signupDriverV2.feature.text1", icon: CarFeatureIcon },
  { titleKey: "signupDriverV2.feature.title2", textKey: "signupDriverV2.feature.text2", icon: ShieldFeatureIcon },
  { titleKey: "signupDriverV2.feature.title3", textKey: "signupDriverV2.feature.text3", icon: StarFeatureIcon },
];

const vehicleClassOptions = [
  { value: "MOTORCYCLE", labelKey: "signupDriverV2.vehicleClass.motorcycle", icon: MotorcycleClassIcon },
  { value: "STANDARD_TAXI", labelKey: "signupDriverV2.vehicleClass.standardTaxi", icon: TaxiClassIcon },
  { value: "TRICYCLE", labelKey: "signupDriverV2.vehicleClass.tricycle", icon: TricycleClassIcon },
];

const taxiTypeByVehicleClass = {
  STANDARD_TAXI: "CAR",
  MOTORCYCLE: "MOTORCYCLE",
  TRICYCLE: "TRICYCLE",
};

const ownershipOptions = [
  { value: "OWN_VEHICLE", labelKey: "signupDriverV2.ownership.own" },
  { value: "NEED_VEHICLE", labelKey: "signupDriverV2.ownership.need" },
];

const genderOptions = [
  { value: "FEMALE", labelKey: "signupDriverV2.gender.female" },
  { value: "MALE", labelKey: "signupDriverV2.gender.male" },
  { value: "OTHER", labelKey: "signupDriverV2.gender.other" },
];

const regionOptions = [
  { value: "Douala", labelKey: "signupDriverV2.region.douala" },
  { value: "Yaoundé", labelKey: "signupDriverV2.region.yaounde" },
  { value: "Bafoussam", labelKey: "signupDriverV2.region.bafoussam" },
  { value: "Bamenda", labelKey: "signupDriverV2.region.bamenda" },
  { value: "Autre", labelKey: "signupDriverV2.region.other" },
];

const permitOptions = [
  { value: "A", labelKey: "signupDriverV2.permit.a" },
  { value: "B", labelKey: "signupDriverV2.permit.b" },
  { value: "C", labelKey: "signupDriverV2.permit.c" },
  { value: "D", labelKey: "signupDriverV2.permit.d" },
];

const hubOptions = [
  { value: "Douala - Akwa", labelKey: "signupDriverV2.hub.doualaAkwa" },
  { value: "Douala - Bonaberi", labelKey: "signupDriverV2.hub.doualaBonaberi" },
  { value: "Yaoundé - Centre", labelKey: "signupDriverV2.hub.yaoundeCentre" },
  { value: "Bafoussam - Centre", labelKey: "signupDriverV2.hub.bafoussamCentre" },
];

const stepIntroEditorialContent = {
  1: {
    eyebrowLines: ["signupDriverV2.intro.eyebrow.step1", "signupDriverV2.intro.eyebrowSub.step1"],
    titleLines: ["signupDriverV2.intro.title.step1.line1", "signupDriverV2.intro.title.step1.line2", "signupDriverV2.intro.title.step1.line3"],
    accentLastLine: true,
    summaryKey: "signupDriverV2.intro.summary.step1",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step1", textKey: "signupDriverV2.intro.item1.text.step1", icon: UserIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step1", textKey: "signupDriverV2.intro.item2.text.step1", icon: ShieldFeatureIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step1", textKey: "signupDriverV2.intro.item3.text.step1", icon: ArrowRightIcon },
    ],
  },
  2: {
    eyebrowLines: ["signupDriverV2.intro.eyebrow.step2", "signupDriverV2.intro.eyebrowSub.step2"],
    titleLines: ["signupDriverV2.intro.title.step2.line1", "signupDriverV2.intro.title.step2.line2"],
    summaryKey: "signupDriverV2.intro.summary.step2",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step2", textKey: "signupDriverV2.intro.item1.text.step2", icon: CheckIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step2", textKey: "signupDriverV2.intro.item2.text.step2", icon: CarFeatureIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step2", textKey: "signupDriverV2.intro.item3.text.step2", icon: ArrowRightIcon },
    ],
  },
  3: {
    eyebrowLines: ["signupDriverV2.intro.eyebrow.step3", "signupDriverV2.intro.eyebrowSub.step3"],
    titleLines: ["signupDriverV2.intro.title.step3.line1", "signupDriverV2.intro.title.step3.line2"],
    summaryKey: "signupDriverV2.intro.summary.step3",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step3", textKey: "signupDriverV2.intro.item1.text.step3", icon: PaperclipIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step3", textKey: "signupDriverV2.intro.item2.text.step3", icon: CheckIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step3", textKey: "signupDriverV2.intro.item3.text.step3", icon: ShieldFeatureIcon },
    ],
  },
  4: {
    eyebrowLines: ["signupDriverV2.intro.eyebrow.step4", "signupDriverV2.intro.eyebrowSub.step4"],
    titleLines: ["signupDriverV2.intro.title.step4.line1", "signupDriverV2.intro.title.step4.line2"],
    summaryKey: "signupDriverV2.intro.summary.step4",
    items: [
      { titleKey: "signupDriverV2.intro.item1.title.step4", textKey: "signupDriverV2.intro.item1.text.step4", icon: UserIcon },
      { titleKey: "signupDriverV2.intro.item2.title.step4", textKey: "signupDriverV2.intro.item2.text.step4", icon: CheckIcon },
      { titleKey: "signupDriverV2.intro.item3.title.step4", textKey: "signupDriverV2.intro.item3.text.step4", icon: ArrowRightIcon },
    ],
  },
};

const documentUploadHintKey = "signupDriverV2.document.hint";

const maxFileSize = 5 * 1024 * 1024;

function getStepStatus(currentStep, stepNumber) {
  if (currentStep > stepNumber) {
    return "complete";
  }

  if (currentStep === stepNumber) {
    return "active";
  }

  return "upcoming";
}

function appendIfPresent(formData, key, value) {
  if (value === undefined || value === null || value === "") {
    return;
  }

  formData.append(key, value);
}

function buildTemporaryPassword(form) {
  const digits = (form.phone || "").replace(/\D/g, "").slice(-6) || "202607";
  return `Mtu@${digits}!`;
}

function normalizeDateDisplay(value) {
  if (!value) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}/${month}/${year}`;
  }

  return value;
}

function getDisplayValue(value, t) {
  return value || t("signupDriverV2.error.noData");
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M9.2 16.2 4.9 11.9l-1.4 1.4 5.7 5.7L20.5 7.7l-1.4-1.4z" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m10 4 8 8-8 8-1.4-1.4 5.6-5.6H4v-2h10.2l-5.6-5.6z" />
    </svg>
  );
}

function ArrowLeftIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14 4 5.7 12 14 20l1.4-1.4-5.6-5.6H20v-2H9.8l5.6-5.6z" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 12.1a4.7 4.7 0 1 0-4.7-4.7 4.7 4.7 0 0 0 4.7 4.7zm0 2.2c-4.2 0-7.6 2.3-7.6 5.1V21h15.2v-1.6c0-2.8-3.4-5.1-7.6-5.1z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M4 6.5h16a1.5 1.5 0 0 1 1.5 1.5v8A1.5 1.5 0 0 1 20 17.5H4A1.5 1.5 0 0 1 2.5 16V8A1.5 1.5 0 0 1 4 6.5zm0 1.9V16h16V8.4l-8 5-8-5z" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M7.8 3.8a1.5 1.5 0 0 1 2.1.2l2 2.6a1.5 1.5 0 0 1-.2 2L10.1 10a11.2 11.2 0 0 0 4 4l1.4-1.6a1.5 1.5 0 0 1 2-.2l2.6 2a1.5 1.5 0 0 1 .2 2.1l-1.2 1.6a2.1 2.1 0 0 1-2.5.7c-5.8-2.1-10.3-6.6-12.4-12.4a2.1 2.1 0 0 1 .7-2.5z" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M7 2.5h2v2h6v-2h2v2h2.2A2.3 2.3 0 0 1 21.5 6.8v12a2.3 2.3 0 0 1-2.3 2.3H4.8a2.3 2.3 0 0 1-2.3-2.3v-12A2.3 2.3 0 0 1 4.8 4.5H7zm12.4 7.1H4.6v9.1h14.8z" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m12 15.4-6-6 1.4-1.4 4.6 4.6 4.6-4.6 1.4 1.4z" />
    </svg>
  );
}

function PaperclipIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M16.8 7.5 10 14.3a3.1 3.1 0 0 0 4.4 4.4l6.4-6.4a5.3 5.3 0 1 0-7.5-7.5L6 12.5a7.5 7.5 0 0 0 10.6 10.6l5.7-5.7-1.4-1.4-5.7 5.7a5.5 5.5 0 0 1-7.8-7.8l7.8-7.8a3.2 3.2 0 1 1 4.6 4.6l-6.4 6.4a1.1 1.1 0 0 1-1.5-1.5l6.8-6.8z" />
    </svg>
  );
}

function MotorcycleClassIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="6.3" cy="17.1" r="2.2" />
      <circle cx="17.7" cy="17.1" r="2.2" />
      <path d="M8 16.7h2.8l1.8-3.7h2.2l1.9 2" />
      <path d="M10.8 13h2.5l1 1.8" />
      <path d="M13.5 10.4h1.8l1 1.4" />
      <path d="M9.3 9.6h1.7l1 1.7" />
    </svg>
  );
}

function TaxiClassIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.1 15.5 6.3 11a2.2 2.2 0 0 1 2.1-1.6h7.2a2.2 2.2 0 0 1 2.1 1.6l1.3 4.5" />
      <path d="M4.6 15.5h14.8" />
      <circle cx="6.7" cy="17.9" r="1.4" />
      <circle cx="17.3" cy="17.9" r="1.4" />
      <path d="M8.9 9.5h6.2l.8-1.4H8.2z" />
      <path d="M11 8.1h2v1.4h-2z" />
    </svg>
  );
}

function TricycleClassIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="6.4" cy="17.2" r="2.1" />
      <circle cx="12" cy="17.2" r="1.7" />
      <circle cx="17.6" cy="17.2" r="2.1" />
      <path d="M7.1 16.8h10.3l1.1-3.1H9z" />
      <path d="M9.1 13.7V9.9h5.5l2.1 3.1" />
      <path d="M12 9.9h2.2" />
      <path d="M14.6 11.1h2" />
    </svg>
  );
}

function CarFeatureIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M5.5 14.1h13l1.4 2.7v3.7h-2.2v-1.4H6.3v1.4H4v-3.7zm2.2-5.8h8.1l1.7 4H6zM7 19.1a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4zm10 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z" />
    </svg>
  );
}

function ShieldFeatureIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2.5 4 5.7v5.1c0 5 3.2 8.9 8 10.7 4.8-1.8 8-5.7 8-10.7V5.7zM11 12.6l5.2-5.2 1.4 1.4L11 15.4 7.4 11.8l1.4-1.4z" />
    </svg>
  );
}

function StarFeatureIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m12 3.2 2.6 5.2 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z" />
    </svg>
  );
}

function Stepper({ currentStep }) {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  const progress = Math.min(
    Math.max(((currentStep - 0.5) / stepLabels.length) * 100, 12.5),
    87.5,
  );

  return (
    <div className="driver-signup-stepper" style={{ "--step-progress": `${progress}%` }}>
      {stepLabels.map((step) => {
        const status = getStepStatus(currentStep, step.number);

        return (
          <div key={step.number} className={`driver-signup-step is-${status}`}>
            <span className="driver-signup-step__dot" aria-hidden="true">
              {status === "complete" ? <CheckIcon /> : step.number}
            </span>
            <div className="driver-signup-step__label">
              {step.lines.map((line) => (
                <span key={line}>{t(line)}</span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function FeatureList({ items }) {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  return (
    <div className="driver-signup-features">
      {items.map((feature) => {
        const Icon = feature.icon;

        return (
          <div className="driver-signup-feature" key={feature.titleKey}>
            <span className="driver-signup-feature__icon" aria-hidden="true">
              <Icon />
            </span>
            <div>
              <h3>{t(feature.titleKey)}</h3>
              <p>{t(feature.textKey)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function StepIntroPanel({ currentStep }) {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const content = stepIntroEditorialContent[currentStep] || stepIntroEditorialContent[4];

  return (
    <div className="driver-signup-intro">
      <div className="driver-signup-intro__eyebrow">
        {content.eyebrowLines.map((line) => (
          <span key={line}>{t(line)}</span>
        ))}
      </div>
      <h2 className="driver-signup-intro__title">
        {content.titleLines.map((line, index) => {
          const isAccent =
            content.accentLastLine && index === content.titleLines.length - 1;

          return (
            <span key={line} className={isAccent ? "is-accent" : ""}>
              {t(line)}
            </span>
          );
        })}
      </h2>
      <p className="driver-signup-intro__summary">{t(content.summaryKey)}</p>
      <div className="driver-signup-intro__divider" aria-hidden="true" />
      <FeatureList items={content.items} />
    </div>
  );
}

function RequiredLabel({ children }) {
  return (
    <span className="driver-signup-required-label">
      {children}
      <span aria-hidden="true" className="driver-signup-required-label__asterisk">
        *
      </span>
    </span>
  );
}

function InputField({
  icon: Icon,
  value,
  onChange,
  placeholder,
  type = "text",
  name,
  error,
  autoComplete,
  inputMode,
  className = "",
}) {
  return (
    <label
      className={`driver-signup-field${error ? " is-error" : ""} ${className}`.trim()}
    >
      {Icon ? (
        <span className="driver-signup-field__icon" aria-hidden="true">
          <Icon />
        </span>
      ) : null}
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        inputMode={inputMode}
        aria-invalid={error ? "true" : "false"}
      />
    </label>
  );
}

function LabeledInput({
  label,
  required,
  value,
  onChange,
  placeholder,
  type = "text",
  name,
  error,
  trailingIcon: TrailingIcon,
  autoComplete,
  inputMode,
  as = "input",
  rows = 3,
  className = "",
}) {
  const showTrailingIcon = Boolean(TrailingIcon) && type !== "date";

  return (
    <label className={`driver-signup-control ${className}`.trim()}>
      <span className="driver-signup-control__label">
        {required ? <RequiredLabel>{label}</RequiredLabel> : label}
      </span>
      <div
        className={`driver-signup-field driver-signup-field--labelled${showTrailingIcon ? " driver-signup-field--has-trailing" : ""}${error ? " is-error" : ""}`.trim()}
      >
        {as === "textarea" ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={rows}
            aria-invalid={error ? "true" : "false"}
          />
        ) : (
          <input
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            autoComplete={autoComplete}
            inputMode={inputMode}
            aria-invalid={error ? "true" : "false"}
          />
        )}

        {showTrailingIcon ? (
          <span className="driver-signup-field__trailing" aria-hidden="true">
            <TrailingIcon />
          </span>
        ) : null}
      </div>
    </label>
  );
}

function SelectField({
  label,
  required,
  value,
  onChange,
  name,
  error,
  children,
  className = "",
}) {
  return (
    <label className={`driver-signup-control ${className}`.trim()}>
      <span className="driver-signup-control__label">
        {required ? <RequiredLabel>{label}</RequiredLabel> : label}
      </span>
      <div
        className={`driver-signup-field driver-signup-field--labelled driver-signup-field--select${error ? " is-error" : ""}`.trim()}
      >
        <select
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          aria-invalid={error ? "true" : "false"}
        >
          {children}
        </select>
        <span className="driver-signup-field__trailing" aria-hidden="true">
          <ChevronDownIcon />
        </span>
      </div>
    </label>
  );
}

function RadioOption({ name, value, label, icon: Icon, checked, onChange }) {
  return (
    <label className="driver-signup-radio">
      <input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
      <span className="driver-signup-radio__mark" aria-hidden="true">
        <span />
      </span>
      <span className="driver-signup-radio__text">
        {Icon ? (
          <span className="driver-signup-radio__icon" aria-hidden="true">
            <Icon />
          </span>
        ) : null}
        <span>{label}</span>
      </span>
    </label>
  );
}

function FileUploadField({
  label,
  hint,
  file,
  onChange,
  error,
  name,
}) {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    if (!file) {
      setPreviewUrl("");
      return undefined;
    }

    const nextPreviewUrl = URL.createObjectURL(file);
    setPreviewUrl(nextPreviewUrl);

    return () => {
      URL.revokeObjectURL(nextPreviewUrl);
    };
  }, [file]);

  return (
    <div className="driver-signup-upload">
      <span className="driver-signup-upload__label">
        {label}
        <span aria-hidden="true" className="driver-signup-required-label__asterisk">
          *
        </span>
      </span>
      <label className={`driver-signup-upload__button${error ? " is-error" : ""}`}>
        <input
          className="driver-signup-upload__input"
          type="file"
          name={name}
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={onChange}
        />
        <span className="driver-signup-upload__icon" aria-hidden="true">
          <PaperclipIcon />
        </span>
        <span className="driver-signup-upload__copy">
          <strong>{t("signupDriverV2.upload.attachFile")}</strong>
          <span>{hint}</span>
        </span>
      </label>
      {file ? (
        <div className="driver-signup-upload__meta">
          <span className="driver-signup-upload__filename">{file.name}</span>
          {previewUrl ? (
            <button
              type="button"
              className="driver-signup-upload__preview"
              onClick={() => window.open(previewUrl, "_blank", "noopener,noreferrer")}
            >
              {t("signupDriverV2.upload.preview")}
            </button>
          ) : null}
        </div>
      ) : null}
      {error ? <p className="driver-signup-error">{error}</p> : null}
    </div>
  );
}

function ChecklistBox({ items, values }) {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  return (
    <div className="driver-signup-checklist">
      <h4 className="driver-signup-checklist__title">{t("signupDriverV2.checklist.title")}</h4>
      <div className="driver-signup-checklist__items">
        {items.map((item) => {
          return (
            <label key={item.id} className="driver-signup-check">
              <input
                type="checkbox"
                checked={Boolean(values[item.id])}
                disabled
                aria-disabled="true"
              />
              <span className="driver-signup-check__box" aria-hidden="true">
                <CheckIcon />
              </span>
              <span>{item.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

function SummaryPanel({ form }) {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  const ownershipOption = ownershipOptions.find((option) => option.value === form.vehicleOwnership);
  const vehicleClassOption = vehicleClassOptions.find((option) => option.value === form.vehicleClass);

  const leftItems = [
    { labelKey: "signupDriverV2.summary.name", value: `${form.firstName} ${form.lastName}`.trim() },
    { labelKey: "signupDriverV2.summary.phone", value: form.phone },
    { labelKey: "signupDriverV2.summary.city", value: form.region },
    {
      labelKey: "signupDriverV2.summary.vehicleOwnership",
      value: ownershipOption ? t(ownershipOption.labelKey) : form.vehicleOwnership,
    },
    { labelKey: "signupDriverV2.summary.license", value: form.driverLicenseNumber },
  ];

  const rightItems = [
    { labelKey: "signupDriverV2.summary.dob", value: normalizeDateDisplay(form.dob) },
    { labelKey: "signupDriverV2.summary.email", value: form.email },
    {
      labelKey: "signupDriverV2.summary.vehicleClass",
      value: vehicleClassOption ? t(vehicleClassOption.labelKey) : form.vehicleClass,
    },
    { labelKey: "signupDriverV2.summary.cniNumber", value: form.cniNumber },
    { labelKey: "signupDriverV2.summary.emergencyPhone", value: form.emergencyPhone },
  ];

  if (form.vehicleOwnership === "OWN_VEHICLE") {
    leftItems.push(
      { labelKey: "signupDriverV2.summary.registration", value: form.vehicleRegistrationNumber },
      { labelKey: "signupDriverV2.summary.makeModel", value: form.vehicleMakeModel },
    );

    rightItems.push(
      { labelKey: "signupDriverV2.summary.year", value: form.vehicleYearOfManufacture },
      { labelKey: "signupDriverV2.summary.insurancePolicy", value: form.insurancePolicyNumber },
      { labelKey: "signupDriverV2.summary.insuranceExpiry", value: normalizeDateDisplay(form.insuranceExpiryDate) },
    );
  }

  return (
    <div className="driver-signup-summary">
      <div className="driver-signup-summary__column">
        {leftItems.map((item) => (
          <div key={item.labelKey} className="driver-signup-summary__item">
            <span className="driver-signup-summary__label">{t(item.labelKey)} :</span>
            <span className="driver-signup-summary__value">{getDisplayValue(item.value, t)}</span>
          </div>
        ))}
      </div>

      <div className="driver-signup-summary__column">
        {rightItems.map((item) => (
          <div key={item.labelKey} className="driver-signup-summary__item">
            <span className="driver-signup-summary__label">{t(item.labelKey)} :</span>
            <span className="driver-signup-summary__value">{getDisplayValue(item.value, t)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function validateStepOne(form) {
  const nextErrors = {};

  if (!form.firstName.trim()) nextErrors.firstName = "signupDriverV2.error.firstName";
  if (!form.lastName.trim()) nextErrors.lastName = "signupDriverV2.error.lastName";
  if (!form.email.trim()) nextErrors.email = "signupDriverV2.error.email";
  if (!form.phone.trim()) nextErrors.phone = "signupDriverV2.error.phone";
  if (!form.dob.trim()) nextErrors.dob = "signupDriverV2.error.dob";
  if (!form.gender.trim()) nextErrors.gender = "signupDriverV2.error.gender";
  if (!form.region.trim()) nextErrors.region = "signupDriverV2.error.region";
  if (!form.address.trim()) nextErrors.address = "signupDriverV2.error.address";

  return nextErrors;
}

function validateStepTwo(form) {
  const nextErrors = {};

  if (!form.vehicleClass.trim()) nextErrors.vehicleClass = "signupDriverV2.error.vehicleClass";
  if (!form.vehicleOwnership.trim()) nextErrors.vehicleOwnership = "signupDriverV2.error.vehicleOwnership";
  if (form.vehicleOwnership === "OWN_VEHICLE") {
    if (!form.vehicleRegistrationNumber.trim()) {
      nextErrors.vehicleRegistrationNumber = "signupDriverV2.error.vehicleRegistrationNumber";
    }
    if (!form.vehicleMakeModel.trim()) {
      nextErrors.vehicleMakeModel = "signupDriverV2.error.vehicleMakeModel";
    }
    if (!form.vehicleYearOfManufacture.trim()) {
      nextErrors.vehicleYearOfManufacture = "signupDriverV2.error.vehicleYearOfManufacture";
    }
    if (!form.insurancePolicyNumber.trim()) {
      nextErrors.insurancePolicyNumber = "signupDriverV2.error.insurancePolicyNumber";
    }
    if (!form.insuranceExpiryDate.trim()) {
      nextErrors.insuranceExpiryDate = "signupDriverV2.error.insuranceExpiryDate";
    }
  }
  if (!form.cniNumber.trim()) nextErrors.cniNumber = "signupDriverV2.error.cniNumber";
  if (!form.driverLicenseNumber.trim()) nextErrors.driverLicenseNumber = "signupDriverV2.error.driverLicenseNumber";
  if (!form.licenseCategory.trim()) nextErrors.licenseCategory = "signupDriverV2.error.licenseCategory";
  if (!form.licenseExpiry.trim()) nextErrors.licenseExpiry = "signupDriverV2.error.licenseExpiry";
  if (!form.preferredHub.trim()) nextErrors.preferredHub = "signupDriverV2.error.preferredHub";
  if (!form.emergencyName.trim()) nextErrors.emergencyName = "signupDriverV2.error.emergencyName";
  if (!form.emergencyPhone.trim()) nextErrors.emergencyPhone = "signupDriverV2.error.emergencyPhone";

  return nextErrors;
}

function validateStepThree(documentTypes, documentFiles) {
  const nextErrors = {};

  documentTypes.forEach((item) => {
    if (!documentFiles[item.id]) {
      nextErrors[item.id] = "signupDriverV2.error.docRequired";
    }
  });

  return nextErrors;
}

function validateStepFour(form) {
  const nextErrors = {};

  if (!form.acceptDeclaration) {
    nextErrors.acceptDeclaration = "signupDriverV2.error.acceptDeclaration";
  }

  return nextErrors;
}

export default function SignUpDriverV2() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);
  const [currentStep, setCurrentStep] = useState(1);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    region: "",
    address: "",
    vehicleClass: "",
    vehicleOwnership: "",
    vehicleRegistrationNumber: "",
    vehicleMakeModel: "",
    vehicleYearOfManufacture: "",
    insurancePolicyNumber: "",
    insuranceExpiryDate: "",
    cniNumber: "",
    driverLicenseNumber: "",
    licenseCategory: "",
    licenseExpiry: "",
    preferredHub: "",
    referralCode: "",
    emergencyName: "",
    emergencyPhone: "",
    acceptDeclaration: false,
  });
  const [documentTypes, setDocumentTypes] = useState([]);
  const [documentTypesLoading, setDocumentTypesLoading] = useState(false);
  const [documentFiles, setDocumentFiles] = useState({});
  const [errors, setErrors] = useState({});
  const [uploadErrors, setUploadErrors] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showVehicleDocs = form.vehicleOwnership === "OWN_VEHICLE";
  const additionalInfoBadge = showVehicleDocs ? "04" : "03";
  const documentsChecklist = documentTypes.reduce((accumulator, item) => {
    accumulator[item.id] = Boolean(documentFiles[item.id]);
    return accumulator;
  }, {});

  useEffect(() => {
    let isMounted = true;
    setDocumentTypesLoading(true);

    DriverApi.getDocumentsTypesV2("DRIVER")
      .then((res) => {
        if (!isMounted) return;
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        setDocumentTypes(list);
      })
      .catch(() => {
        if (isMounted) setDocumentTypes([]);
      })
      .finally(() => {
        if (isMounted) setDocumentTypesLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  function updateField(field) {
    return (event) => {
      const value = event.target.value;
      setForm((current) => ({
        ...current,
        [field]: value,
      }));
    };
  }

  function handleRadioChange(field, value) {
    setForm((current) => ({
      ...current,
      [field]: value,
    }));

    if (field === "vehicleOwnership" && value !== "OWN_VEHICLE") {
      setForm((current) => ({
        ...current,
        vehicleRegistrationNumber: "",
        vehicleMakeModel: "",
        vehicleYearOfManufacture: "",
        insurancePolicyNumber: "",
        insuranceExpiryDate: "",
      }));
      setErrors((current) => {
        const nextErrors = { ...current };
        delete nextErrors.vehicleRegistrationNumber;
        delete nextErrors.vehicleMakeModel;
        delete nextErrors.vehicleYearOfManufacture;
        delete nextErrors.insurancePolicyNumber;
        delete nextErrors.insuranceExpiryDate;
        return nextErrors;
      });
    }
  }

  function handleDocumentFileChange(documentTypeId) {
    return (event) => {
      const file = event.target.files?.[0];

      if (!file) {
        return;
      }

      if (file.size > maxFileSize) {
        setUploadErrors((current) => ({
          ...current,
          [documentTypeId]: "signupDriverV2.error.fileSize",
        }));
        return;
      }

      setUploadErrors((current) => ({
        ...current,
        [documentTypeId]: "",
      }));

      setDocumentFiles((current) => ({
        ...current,
        [documentTypeId]: file,
      }));
    };
  }

  function goNext() {
    let nextErrors = {};

    if (currentStep === 1) {
      nextErrors = validateStepOne(form);
    } else if (currentStep === 2) {
      nextErrors = validateStepTwo(form);
    } else if (currentStep === 3) {
      nextErrors = validateStepThree(documentTypes, documentFiles);
    }

    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      return;
    }

    setCurrentStep((current) => Math.min(current + 1, 4));
  }

  function goBack() {
    setErrors({});
    setCurrentStep((current) => Math.max(current - 1, 1));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const nextErrors = validateStepFour(form);
    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      return;
    }

    const applicationPayload = new FormData();
    const hiddenPassword = buildTemporaryPassword(form);
    const isVehicleOwner = form.vehicleOwnership === "OWN_VEHICLE";

    appendIfPresent(applicationPayload, "firstName", form.firstName.trim());
    appendIfPresent(applicationPayload, "lastName", form.lastName.trim());
    appendIfPresent(applicationPayload, "phone", form.phone.trim());
    appendIfPresent(applicationPayload, "email", form.email.trim());
    appendIfPresent(applicationPayload, "password", hiddenPassword);
    appendIfPresent(applicationPayload, "userType", "DRIVER");
    appendIfPresent(applicationPayload, "city", form.region.trim());
    appendIfPresent(applicationPayload, "country", "CM");
    appendIfPresent(applicationPayload, "address", form.address.trim());
    appendIfPresent(applicationPayload, "referral_code", form.referralCode.trim());
    appendIfPresent(applicationPayload, "vehicle_owner", isVehicleOwner ? 1 : 0);
    appendIfPresent(applicationPayload, "taxi_type", taxiTypeByVehicleClass[form.vehicleClass]);
    appendIfPresent(applicationPayload, "cni_number", form.cniNumber.trim());
    appendIfPresent(applicationPayload, "license_category", form.licenseCategory.trim());
    appendIfPresent(
      applicationPayload,
      "driver_license_number",
      form.driverLicenseNumber.trim(),
    );
    appendIfPresent(applicationPayload, "license_expiry_date", form.licenseExpiry.trim());

    if (isVehicleOwner) {
      appendIfPresent(applicationPayload, "vehicle_no", form.vehicleRegistrationNumber.trim());
      appendIfPresent(applicationPayload, "vehicle_brand", form.vehicleMakeModel.trim());
      appendIfPresent(
        applicationPayload,
        "manufacturing_year",
        form.vehicleYearOfManufacture.trim(),
      );
      appendIfPresent(applicationPayload, "insurance_no", form.insurancePolicyNumber.trim());
      appendIfPresent(applicationPayload, "insurance_exp", form.insuranceExpiryDate.trim());
    }

    // Champs collectés par le formulaire mais hors du contrat minimal /api/v2/auth/register :
    // conservés pour ne pas perdre ces données saisies par le chauffeur.
    appendIfPresent(applicationPayload, "dob", form.dob.trim());
    appendIfPresent(applicationPayload, "gender", form.gender.trim());
    appendIfPresent(applicationPayload, "preferredHub", form.preferredHub.trim());
    appendIfPresent(applicationPayload, "emergencyName", form.emergencyName.trim());
    appendIfPresent(applicationPayload, "emergencyPhone", form.emergencyPhone.trim());
    appendIfPresent(applicationPayload, "acceptDeclaration", String(form.acceptDeclaration));

    documentTypes
      .map((item) => ({ item, file: documentFiles[item.id] }))
      .filter((entry) => Boolean(entry.file))
      .forEach((entry, index) => {
        applicationPayload.append(`documents[${index}][image]`, entry.file);
        applicationPayload.append(`documents[${index}][document_type_id]`, entry.item.id);
        applicationPayload.append(`documents[${index}][driver_id]`, "");
      });

    dispatch(showLoader(t("signupDriverV2.loader.submitting")));

    try {
      await RegisterApi.registerV2(applicationPayload);
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: t("signupDriverV2.success.message"),
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "success",
        }),
      );
      navigate("/login");
    } catch (error) {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            t("signupDriverV2.error.submitFailed"),
          autoHideDuration: 4000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        }),
      );
    }
  }

  const submitLabel = currentStep === 4 ? t("signupDriverV2.btn.submit") : t("signupDriverV2.btn.continue");

  return (
    <div className="driver-signup-page">
      <a className="driver-signup-skip" href="#main-content">
        {t("signupDriverV2.skipToMain")}
      </a>

      <Header />

      <main className="driver-signup-page__main" id="main-content">
        <div className="driver-signup-shell">

          <section className="driver-signup-card" aria-label={t("signupDriverV2.section.title.personalInfo")}>
            <aside className="driver-signup-card__intro">
              <StepIntroPanel currentStep={currentStep} />
            </aside>

            <section className="driver-signup-card__form">
              <div className="driver-signup-form__stepper">
                <Stepper currentStep={currentStep} />
              </div>

              <form className="driver-signup-form" onSubmit={handleSubmit}>
                {currentStep === 1 ? (
                  <div className="driver-signup-form__section">
                    <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.personalInfo")}</h3>
                    <p className="driver-signup-section__subtitle">
                      {t("signupDriverV2.section.subtitle.personalInfo")}
                    </p>

                    <div className="driver-signup-grid driver-signup-grid--2">
                      <InputField
                        icon={UserIcon}
                        placeholder={t("signupDriverV2.placeholder.firstName")}
                        name="firstName"
                        value={form.firstName}
                        onChange={updateField("firstName")}
                        error={errors.firstName ? t(errors.firstName) : ""}
                        autoComplete="given-name"
                      />
                      <InputField
                        icon={UserIcon}
                        placeholder={t("signupDriverV2.placeholder.lastName")}
                        name="lastName"
                        value={form.lastName}
                        onChange={updateField("lastName")}
                        error={errors.lastName ? t(errors.lastName) : ""}
                        autoComplete="family-name"
                      />
                    </div>

                    <InputField
                      icon={MailIcon}
                      placeholder={t("signupDriverV2.placeholder.email")}
                      name="email"
                      value={form.email}
                      onChange={updateField("email")}
                      error={errors.email ? t(errors.email) : ""}
                      autoComplete="email"
                    />

                    <InputField
                      icon={PhoneIcon}
                      placeholder={t("signupDriverV2.placeholder.phone")}
                      name="phone"
                      value={form.phone}
                      onChange={updateField("phone")}
                      error={errors.phone ? t(errors.phone) : ""}
                      autoComplete="tel"
                    />

                    <div className="driver-signup-grid driver-signup-grid--2">
                      <LabeledInput
                        label={t("signupDriverV2.label.dob")}
                        required
                        name="dob"
                        value={form.dob}
                        onChange={updateField("dob")}
                        placeholder={t("signupDriverV2.placeholder.dob")}
                        error={errors.dob ? t(errors.dob) : ""}
                        type="date"
                        trailingIcon={CalendarIcon}
                      />

                      <SelectField
                        label={t("signupDriverV2.label.gender")}
                        required
                        name="gender"
                        value={form.gender}
                        onChange={updateField("gender")}
                        error={errors.gender ? t(errors.gender) : ""}
                      >
                        <option value="" disabled>
                          {t("signupDriverV2.select.placeholder")}
                        </option>
                        {genderOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {t(option.labelKey)}
                          </option>
                        ))}
                      </SelectField>
                    </div>

                    <SelectField
                      label={t("signupDriverV2.label.region")}
                      required
                      name="region"
                      value={form.region}
                      onChange={updateField("region")}
                      error={errors.region ? t(errors.region) : ""}
                    >
                      <option value="" disabled>
                        {t("signupDriverV2.select.placeholder")}
                      </option>
                      {regionOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {t(option.labelKey)}
                        </option>
                      ))}
                    </SelectField>

                    <LabeledInput
                      label={t("signupDriverV2.label.address")}
                      required
                      name="address"
                      value={form.address}
                      onChange={updateField("address")}
                      placeholder={t("signupDriverV2.placeholder.address")}
                      error={errors.address ? t(errors.address) : ""}
                    />
                  </div>
                ) : null}

                {currentStep === 2 ? (
                  <>
                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">01</span>
                        <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.vehicleClass")}</h3>
                      </div>

                      <div className="driver-signup-radio-row">
                        {vehicleClassOptions.map((option) => (
                          <RadioOption
                            key={option.value}
                            name="vehicleClass"
                            value={option.value}
                            label={t(option.labelKey)}
                            icon={option.icon}
                            checked={form.vehicleClass === option.value}
                            onChange={() => handleRadioChange("vehicleClass", option.value)}
                          />
                        ))}
                      </div>
                      {errors.vehicleClass ? <p className="driver-signup-error">{t(errors.vehicleClass)}</p> : null}

                      <h4 className="driver-signup-section__subtitle" style={{ marginTop: 4 }}>
                        {t("signupDriverV2.section.title.vehicleOwnership")}
                      </h4>
                      <div className="driver-signup-radio-row">
                        {ownershipOptions.map((option) => (
                          <RadioOption
                            key={option.value}
                            name="vehicleOwnership"
                            value={option.value}
                            label={t(option.labelKey)}
                            checked={form.vehicleOwnership === option.value}
                            onChange={() => handleRadioChange("vehicleOwnership", option.value)}
                          />
                        ))}
                      </div>
                      {errors.vehicleOwnership ? <p className="driver-signup-error">{t(errors.vehicleOwnership)}</p> : null}
                    </div>

                    <div className="driver-signup-divider" />

                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">02</span>
                        <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.identification")}</h3>
                      </div>

                      <div className="driver-signup-grid driver-signup-grid--2">
                        <LabeledInput
                          label={t("signupDriverV2.label.cniNumber")}
                          required
                          name="cniNumber"
                          value={form.cniNumber}
                          onChange={updateField("cniNumber")}
                          placeholder={t("signupDriverV2.placeholder.cni")}
                          error={errors.cniNumber ? t(errors.cniNumber) : ""}
                        />

                        <LabeledInput
                          label={t("signupDriverV2.label.licenseNumber")}
                          required
                          name="driverLicenseNumber"
                          value={form.driverLicenseNumber}
                          onChange={updateField("driverLicenseNumber")}
                          placeholder={t("signupDriverV2.placeholder.license")}
                          error={errors.driverLicenseNumber ? t(errors.driverLicenseNumber) : ""}
                        />
                      </div>

                    <div className="driver-signup-grid driver-signup-grid--2">
                      <SelectField
                        label={t("signupDriverV2.label.licenseCategory")}
                        required
                        name="licenseCategory"
                          value={form.licenseCategory}
                          onChange={updateField("licenseCategory")}
                          error={errors.licenseCategory ? t(errors.licenseCategory) : ""}
                        >
                          <option value="" disabled>
                            {t("signupDriverV2.select.placeholder")}
                          </option>
                          {permitOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {t(option.labelKey)}
                            </option>
                          ))}
                        </SelectField>

                        <LabeledInput
                        label={t("signupDriverV2.label.licenseExpiry")}
                        required
                        name="licenseExpiry"
                        value={form.licenseExpiry}
                        onChange={updateField("licenseExpiry")}
                        placeholder={t("signupDriverV2.placeholder.dob")}
                        error={errors.licenseExpiry ? t(errors.licenseExpiry) : ""}
                        type="date"
                        trailingIcon={CalendarIcon}
                      />
                      </div>

                      {showVehicleDocs ? (
                        <div className="driver-signup-form__section">
                          <div className="driver-signup-section__header">
                            <span className="driver-signup-section__badge">03</span>
                            <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.vehicleDocs")}</h3>
                          </div>

                          <div className="driver-signup-grid driver-signup-grid--2">
                            <LabeledInput
                              label={t("signupDriverV2.label.vehicleRegistration")}
                              required
                              name="vehicleRegistrationNumber"
                              value={form.vehicleRegistrationNumber}
                              onChange={updateField("vehicleRegistrationNumber")}
                              placeholder={t("signupDriverV2.placeholder.registration")}
                              error={errors.vehicleRegistrationNumber ? t(errors.vehicleRegistrationNumber) : ""}
                            />

                            <LabeledInput
                              label={t("signupDriverV2.label.vehicleMakeModel")}
                              required
                              name="vehicleMakeModel"
                              value={form.vehicleMakeModel}
                              onChange={updateField("vehicleMakeModel")}
                              placeholder={t("signupDriverV2.placeholder.makeModel")}
                              error={errors.vehicleMakeModel ? t(errors.vehicleMakeModel) : ""}
                            />

                            <LabeledInput
                              label={t("signupDriverV2.label.vehicleYear")}
                              required
                              name="vehicleYearOfManufacture"
                              value={form.vehicleYearOfManufacture}
                              onChange={updateField("vehicleYearOfManufacture")}
                              placeholder={t("signupDriverV2.placeholder.year")}
                              error={errors.vehicleYearOfManufacture ? t(errors.vehicleYearOfManufacture) : ""}
                              inputMode="numeric"
                              type="number"
                            />

                            <LabeledInput
                              label={t("signupDriverV2.label.insurancePolicy")}
                              required
                              name="insurancePolicyNumber"
                              value={form.insurancePolicyNumber}
                              onChange={updateField("insurancePolicyNumber")}
                              placeholder={t("signupDriverV2.placeholder.insurance")}
                              error={errors.insurancePolicyNumber ? t(errors.insurancePolicyNumber) : ""}
                            />

                            <LabeledInput
                              label={t("signupDriverV2.label.insuranceExpiry")}
                              required
                              name="insuranceExpiryDate"
                              value={form.insuranceExpiryDate}
                              onChange={updateField("insuranceExpiryDate")}
                              placeholder={t("signupDriverV2.placeholder.dob")}
                              error={errors.insuranceExpiryDate ? t(errors.insuranceExpiryDate) : ""}
                              type="date"
                              trailingIcon={CalendarIcon}
                              className="driver-signup-control--span-2"
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="driver-signup-divider" />

                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">{additionalInfoBadge}</span>
                        <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.additionalInfo")}</h3>
                      </div>

                      <div className="driver-signup-grid driver-signup-grid--2">
                        <SelectField
                          label={t("signupDriverV2.label.preferredHub")}
                          required
                          name="preferredHub"
                          value={form.preferredHub}
                          onChange={updateField("preferredHub")}
                          error={errors.preferredHub ? t(errors.preferredHub) : ""}
                        >
                          <option value="" disabled>
                            {t("signupDriverV2.select.hubPlaceholder")}
                          </option>
                          {hubOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {t(option.labelKey)}
                            </option>
                          ))}
                        </SelectField>

                        <LabeledInput
                          label={t("signupDriverV2.label.referralCode")}
                          name="referralCode"
                          value={form.referralCode}
                          onChange={updateField("referralCode")}
                          placeholder={t("signupDriverV2.placeholder.referral")}
                          error={errors.referralCode ? t(errors.referralCode) : ""}
                        />
                      </div>

                      <div className="driver-signup-grid driver-signup-grid--2">
                        <LabeledInput
                          label={t("signupDriverV2.label.emergencyName")}
                          required
                          name="emergencyName"
                          value={form.emergencyName}
                          onChange={updateField("emergencyName")}
                          placeholder={t("signupDriverV2.placeholder.emergencyName")}
                          error={errors.emergencyName ? t(errors.emergencyName) : ""}
                        />

                        <LabeledInput
                          label={t("signupDriverV2.label.emergencyPhone")}
                          required
                          name="emergencyPhone"
                          value={form.emergencyPhone}
                          onChange={updateField("emergencyPhone")}
                          placeholder={t("signupDriverV2.placeholder.emergencyPhone")}
                          error={errors.emergencyPhone ? t(errors.emergencyPhone) : ""}
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {currentStep === 3 ? (
                  <>
                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">01</span>
                        <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.documents")}</h3>
                      </div>
                      <p className="driver-signup-section__subtitle">
                        {t("signupDriverV2.section.subtitle.documents")}
                      </p>

                      {documentTypesLoading ? (
                        <p className="driver-signup-section__subtitle">
                          {t("signupDriverV2.section.subtitle.loading")}
                        </p>
                      ) : null}

                      {!documentTypesLoading && documentTypes.length === 0 ? (
                        <p className="driver-signup-error">
                          {t("signupDriverV2.error.loadDocsFailed")}
                        </p>
                      ) : null}

                      {documentTypes.map((item) => (
                        <FileUploadField
                          key={item.id}
                          label={item.documentType}
                          hint={t(documentUploadHintKey)}
                          name={`document-${item.id}`}
                          file={documentFiles[item.id]}
                          onChange={handleDocumentFileChange(item.id)}
                          error={
                            uploadErrors[item.id]
                              ? t(uploadErrors[item.id])
                              : errors[item.id]
                                ? `${item.documentType} ${t(errors[item.id])}`
                                : ""
                          }
                        />
                      ))}

                      <ChecklistBox
                        items={documentTypes.map((item) => ({
                          id: item.id,
                          label: item.documentType,
                        }))}
                        values={documentsChecklist}
                      />
                    </div>
                  </>
                ) : null}

                {currentStep === 4 ? (
                  <>
                    <div className="driver-signup-form__section">
                      <div className="driver-signup-section__header">
                        <span className="driver-signup-section__badge">04</span>
                        <h3 className="driver-signup-section__title">{t("signupDriverV2.section.title.verification")}</h3>
                      </div>
                      <p className="driver-signup-section__subtitle">
                        {t("signupDriverV2.section.subtitle.verification")}
                      </p>

                      <SummaryPanel form={form} />
                    </div>

                    <div className="driver-signup-declaration">
                      <strong>{t("signupDriverV2.declaration.title")}</strong>{" "}
                      {t("signupDriverV2.declaration.text")}
                    </div>

                    <label className="driver-signup-consent">
                      <input
                        type="checkbox"
                        checked={form.acceptDeclaration}
                        onChange={(event) =>
                          setForm((current) => ({
                            ...current,
                            acceptDeclaration: event.target.checked,
                          }))
                        }
                      />
                      <span className="driver-signup-consent__box" aria-hidden="true">
                        <CheckIcon />
                      </span>
                      <span className="driver-signup-consent__text">
                        <FormattedMessage
                          id="signupDriverV2.consent.text"
                          values={{
                            termsLink: <Link to="/terms-conditions">{t("signupDriverV2.consent.terms")}</Link>,
                          }}
                        />
                      </span>
                    </label>
                    {errors.acceptDeclaration ? <p className="driver-signup-error">{t(errors.acceptDeclaration)}</p> : null}
                  </>
                ) : null}

                <div className="driver-signup-actions">
                  {currentStep > 1 ? (
                    <button type="button" className="driver-signup-back" onClick={goBack}>
                      <ArrowLeftIcon />
                      {t("signupDriverV2.btn.back")}
                    </button>
                  ) : (
                    <span />
                  )}

                  {currentStep === 4 ? (
                    <button type="submit" className="driver-signup-primary">
                      {submitLabel}
                      <ArrowRightIcon />
                    </button>
                  ) : (
                    <button type="button" className="driver-signup-primary" onClick={goNext}>
                      {submitLabel}
                      <ArrowRightIcon />
                    </button>
                  )}
                </div>
              </form>
            </section>

          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
